import {Route} from 'vue-router';
import PerRoadScenarioInfo from '@/modules/perRoad/views/1 - ScenarioInfo.vue';
import PerRoadScenarioContainer from '@/modules/perRoad/views/components/PerRoadScenarioContainer.vue';
import PerRoadTraffic from '@/modules/perRoad/views/2 - Traffic.vue';
import PerRoadLayers from '@/modules/perRoad/views/3 - Layers.vue';
import PerRoadLayerPerformance from '@/modules/perRoad/views/4 - Criteria.vue';
import PerRoadSimulation from '@/modules/perRoad/views/5 - Simulation.vue';
import WesleaDevFixture from "@/modules/perRoad/views/components/inspection/WesleaDevFixture.vue";

export const perRoadPages = [
  {link: '1', text: 'Scenario Info'},
  {link: '2', text: 'Traffic'},
  {link: '3', text: 'Layer Structure'},
  {link: '4', text: 'Performance Criteria'},
  {link: '5', text: 'Simulation'},
];

export const perRoadRoutes = {
  path: '/projects/perroad/:pxId',
  name: 'perRoad',
  redirect: '/projects/perroad/:pxId/1',
  component: PerRoadScenarioContainer,
  props: (route: Route) => ({
    id: route.params.pxId,
    pages: perRoadPages,
  }),
  children: [
    {
      path: '1',
      component: PerRoadScenarioInfo,
      props: (route: Route) => ({pxDesignId: route.params.pxDesignId, page: 1}),
    },
    {
      path: '2',
      component: PerRoadTraffic,
      props: (route: Route) => ({pxDesignId: route.params.pxDesignId, page: 2}),
    },
    {
      path: '3',
      component: PerRoadLayers,
      props: (route: Route) => ({pxDesignId: route.params.pxDesignId, page: 3}),
    },
    {
      path: '4',
      component: PerRoadLayerPerformance,
      props: (route: Route) => ({pxDesignId: route.params.pxDesignId, page: 4}),
    },
    {
      path: '5',
      component: PerRoadSimulation,
      props: (route: Route) => ({pxDesignId: route.params.pxDesignId, page: 5}),
    },
    {
      path: 'test',
      component: WesleaDevFixture,
      props: (route: Route) => ({pxDesignId: route.params.pxDesignId, page: 5}),
    },
  ],
};
